import { DictionaryItem } from '@hglobal/fin-ui';

export enum Role {
  Admin = 'admin',
  SuperAdmin = 'Superadmin',
  Buyer = 'buyer',
  Supervisor = 'Supervisor',
  AAOwner = 'aa_owner',
  AAManager = 'aa_manager',
  AASupervisor = 'aa_supervisor',
}

export enum RoleFromAPI {
  Admin = 'admin',
  SuperAdmin = 'Super admin',
  Buyer = 'buyer',
  Supervisor = 'Supervisor',
  AAOwner = 'aa_owner',
  AAManager = 'aa_manager',
  AASupervisor = 'aa_supervisor',
}

export const parseRoleFromApi = (role: Role | string): Role => {
  return role.replaceAll(/\s/g, '') as Role;
};

const KNOWN_ROLES = new Set<string>(Object.values(Role));

export const parseAccessRoleList = (roles: string[] | Role[] | null | undefined): Role[] => {
  if (!roles?.length) return [];

  return roles.map(parseRoleFromApi).filter((role): role is Role => KNOWN_ROLES.has(role));
};

export const mapRoleListFromApi = (
  roles: string[] | Role[] | null | undefined,
  rolesDictionary: Map<Role, string>,
): DictionaryItem<string>[] => {
  const mappedRoles = [];

  for (const item of roles ?? []) {
    const parsedRole = parseRoleFromApi(item);
    const mappedRole = rolesDictionary.get(parsedRole);
    if (mappedRole) {
      mappedRoles.push({ id: parsedRole, name: mappedRole });
    }
  }

  return mappedRoles;
};
